<template>
    <div class="page">
        <div class="title">{{ title }}</div>
        <div class="time">{{ pub_time }}</div>
        <div class="content" v-html="content"></div>
    </div>
</template>

<script>
import userCenterService from "../../service/user-center.service";
export default {
    name: "zanneixin-detail",
    data() {
        return {
            id: "",
            title: "",
            pub_time: "",
            content: ""
        };
    },
    mounted() {
        this.id = this.$route.params.id;
        this.getLetterById();
    },
    methods: {
        getLetterById() {
            userCenterService.getLetterById({ id: this.id }).then(res => {
                this.title = res.data.title;
                this.pub_time = res.data.pub_time;
                this.content = res.data.content;
            });
        }
    }
};
</script>

<style lang="scss" scoped src="./zanneixin-detail.scss">
</style>